/***
 * lodop打印
 */
import { lodopUtils } from 'pangu-core'
import { pgMessage } from '../../message/index'
import { printTemplateCompile } from './print-template-compile'
export class LodopPrint {
  constructor() {
    this.OPrinter = lodopUtils()
    this.printerData = { defaultPrinterName: null }
  }
  //判断是否显示打印的总页数
  allPage(allPage) {
    allPage && this.OPrinter.allPage()
  }
  //预览
  preview(allPage) {
    this.allPage(allPage)
    this.OPrinter.preview()
  }
  //增加页
  addPage(content, num, newPage = true) {
    const len = num && num !== 'undefined' ? num : 1
    // 需求6543 ：模板内容（content）存在才进行下一步
    if (content) {
      for (let i = 0; i < len; i++) {
        this.OPrinter.addContent(content, !newPage && i === 0 ? false : true)
      }
    }
  }
  //打印
  print(num = 1, allPage) {
    this.allPage(allPage)
    this.OPrinter.print(num)
  }
  _printBeforePrint() {
    this.OPrinter._printBeforePrint()
  }
  //获取打印机
  async getPrinter() {
    return new Promise((resolve) => {
      this.OPrinter.init({}, () => {
        resolve(this.OPrinter.getPrinters())
      })
    })
  }
  //设置打印机
  setPrinterIndex(index) {
    if (index && index !== 0) {
      this.OPrinter.setPrinterIndex(index)
    }
  }
  //设置打印尺寸
  setSize(data) {
    // "papper": "A4|A3|FREE",
    // "orientation": "horizontal|vertical",
    // "width": 1,
    // "height": 1,
    // "top": 1,
    // "bottom": 1,
    // "left": 1,
    // "right": 1
    let temp = {
      print_orient: data.orientation == 'horizontal' ? 2 : 1, //打印方向及纸张类型，数字型.1---纵(正)向打印，固定纸张；
      paper_top: 0, //整页上边距，整数或字符型
      paper_left: 0, //整页左边距
      paper_width: data.width + 'mm', //可视编辑区域的宽度.A4 21*29.7cm（210mm×297mm）
      paper_height: data.height + 'mm', //可视编辑区域的高度
      html_top: data.top + 'mm', //html上边距，整数或字符型
      html_left: data.left + 'mm', //html上边距，整数或字符型
      html_width: data.orientation == 'horizontal' ? data.right + 'mm' : data.right + 10.2 + 'mm', //html右边距（10.2是误差）
      html_height: data.orientation == 'horizontal' ? data.bottom + 'mm' : data.bottom + 'mm', //html下边距
    }
    this.OPrinter.setPrint_paramByUICustomHtml(temp)
  }

  run({ printSize, printTemplateContents, printer = {} }) {
    return new Promise((resolve, reject) => {
      this.OPrinter.init(this.printerData, () => {
        const { print = false, printerIndex = null, allPage } = printer
        this.setSize(printSize)
        this._printBeforePrint()

        for (let i = 0; i < printTemplateContents.length; i++) {
          this.addPage(
            printTemplateContents[i].content,
            printTemplateContents[i]._print_,
            i === 0 ? false : true
          )
        }

        this.setPrinterIndex(printerIndex)
        // 需求6543
        if (printTemplateContents && printTemplateContents.length > 0) {
          !print ? this.preview(allPage) : this.print(1, allPage)
          resolve()
        } else {
          pgMessage.error(`因数量为零的数据已过滤,目前无打印数据~`)
          reject()
        }
      })
    })
  }
}

export async function lodop({ compileDatas, printTemplate, printer }) {
  const { printTemplateContents } = await printTemplateCompile({
    compileDatas,
    printTemplate,
    html: true,
  })
  const OPrinter = new LodopPrint()
  return OPrinter.run({
    printSize: printTemplate.print,
    printTemplateContents,
    printer: {
      allPage: compileDatas[0].compileSource.allPage,
      ...printTemplate.dataset?.staticData,
      ...printer,
    },
  })
}
